import React from 'react'

const RequestWarrantyRepairPage = React.lazy(() => import('pages/RequestWarrantyRepair/pages/RequestWarrantyRepairPage'));
const RequestWarrantyRepairAddPage = React.lazy(() => import('pages/RequestWarrantyRepair/pages/RequestWarrantyRepairAddPage'));
const RequestWarrantyRepairDetailPage = React.lazy(() => import('pages/RequestWarrantyRepair/pages/RequestWarrantyRepairDetailPage'));

const RequestWarrantyRepairRoutes = [
    {
        path: '/request-warranty-repair',
        exact: true,
        name: 'Danh sách phiếu yêu cầu',
        function: 'RS_RQ_WARRANTY_REPAIR_VIEW',
        component: RequestWarrantyRepairPage,
    },
    {
        path: '/request-warranty-repair/add',
        exact: true,
        name: 'Tạo mới phiếu yêu cầu',
        function: 'RS_RQ_WARRANTY_REPAIR_ADD',
        component: RequestWarrantyRepairAddPage,
    },
    {
        path: '/request-warranty-repair/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_RQ_WARRANTY_REPAIR_VIEW',
        component: RequestWarrantyRepairDetailPage,
    },
    {
        path: '/request-warranty-repair/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_RQ_WARRANTY_REPAIR_EDIT',
        component: RequestWarrantyRepairAddPage,
    },
    {
        path: '/request-warranty-repair/copy/:id/:warranty_transfer_id/:request_type_tranfer_id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_RQ_WARRANTY_REPAIR_COPY',
        component: RequestWarrantyRepairAddPage,
    },
]

export default RequestWarrantyRepairRoutes
